import Notification from '../../shared/notification';
import loadCartFormHndb from '../templates/load-cart-form.handlebars';
import { getRedirectUrl } from '../../shared/shared';
import { LocalQuote } from '../local-quote';
import { View } from './view';

export default class LoadCustomerCart extends View {
    constructor(view, data = null, app, { preSubmit = null, postSubmit = null } = {}) {
        super(view);
        this.data = data;
        this.app = app;
        this.form = null;
        this.preSubmit = preSubmit;
        this.postSubmit = postSubmit;
    }

    #listeners = () => {
        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const notification = new Notification({
                type: 'loading',
            });
            notification.open();

            const form = {};

            for (const [key, value] of new FormData(e.target).entries()) {
                form[key] = value;
            }

            if (this.preSubmit) {
                this.preSubmit(form);
            }

            const {data: redirect, message, status} = await this.app.service.loadCustomerCart(this.data.sellerCartId, form);

            if (this.postSubmit) {
                this.postSubmit(prospectRes);
            }

            if (status === 0) {
                if (form.tcc && !form.mode) {
                    // If only TCC is provided without checkbox, replace cart
                    this.app.session.sessionDetails = {
                        tcc: form.tcc
                    }
                    LocalQuote.remove(this.data.sellerCartId);
                };
                location.href = getRedirectUrl(redirect.cart_url);
            } else {
                notification.reload({
                    type: 'error',
                    title: message,
                });
            }
        });

        this.form.addEventListener('click', (e) => {
            if (e.target.value == 'Cancel') {
                this.close();
            }
        });
    };

    load() {
        this.form = this.view.update(loadCartFormHndb(this.data)).modalContainer;
        this.view.open();

        this.#listeners();
    }
}
